import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const PlusCircleIcon = (props?: SvgProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="#19191B"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>

      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="white" />
      <path
        d="M10 5.91663V14.0833M5.91667 9.99996H14.0833"
        strokeWidth="0.954545"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
